import * as React from 'react';
import { BraintreeTokenizePayload } from '@paypal/react-paypal-js/dist/types/types/braintree/commonsTypes';
import { PaypalButton } from './paypal-button/paypal-button.component';
import { PaypalProvider } from './paypal-flow-new/paypal-provider/paypal-provider.component';

interface Props {
  className?: string;
  onApprove: (payload: BraintreeTokenizePayload) => void;
}

export const PaypalAuthButton: React.FC<Props> = (props) => {
  const { className, onApprove } = props;

  return (
    <div className={className}>
      <PaypalProvider>
        <PaypalButton onApprove={onApprove} />
      </PaypalProvider>
    </div>
  );
};
